import { useEffect, type ReactNode } from 'react';
import { errorKey, useT } from '../i18n/index.js';
import { useGameStore } from '../store/gameStore.js';

/** Mensagens curtas e não intrusivas. Nunca usamos alerts nativos. */
export function Toasts(): ReactNode {
  const t = useT();
  const toast = useGameStore((state) => state.toast);
  const clearToast = useGameStore((state) => state.clearToast);

  useEffect(() => {
    if (!toast) return;
    const handle = window.setTimeout(clearToast, 3600);
    return () => window.clearTimeout(handle);
  }, [toast, clearToast]);

  if (!toast) return null;

  return (
    <div
      className="safe-x pointer-events-none fixed inset-x-0 bottom-24 z-[60] flex justify-center px-4"
      role="status"
      aria-live="polite"
    >
      <p
        className="animate-rise glass max-w-sm rounded-2xl px-4 py-3 text-center text-sm text-night-200 shadow-xl"
        data-testid="toast"
      >
        {t(errorKey(toast.code))}
      </p>
    </div>
  );
}

/** Indicador persistente de conexão instável. */
export function ConnectionBanner(): ReactNode {
  const t = useT();
  const connection = useGameStore((state) => state.connection);

  if (connection === 'connected' || connection === 'idle') return null;

  return (
    <div
      className="safe-top fixed inset-x-0 top-0 z-[60] flex justify-center px-4"
      role="status"
      aria-live="polite"
    >
      <p
        className="rounded-b-2xl bg-life/90 px-4 py-1.5 text-xs font-medium text-night-950"
        data-testid="connection-banner"
      >
        {connection === 'connecting' ? t('common.reconnecting') : t('common.offline')}
      </p>
    </div>
  );
}
